var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
          _c(
            "b-button",
            {
              staticClass: "left-right",
              attrs: {
                tag: "router-link",
                to: {
                  name: "closure-templates",
                  params: { collect_group: this.$route.params.collect_group },
                },
                type: "is-info",
                "icon-left": "arrow-left",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.back")) + " ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pages.closure_schedule.mail_templates.template_form.name_field"
                        ),
                      },
                    },
                    [
                      _c("b-input", {
                        attrs: { placeholder: "Template Name" },
                        model: {
                          value: _vm.templateName,
                          callback: function ($$v) {
                            _vm.templateName = $$v
                          },
                          expression: "templateName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pages.closure_schedule.mail_templates.template_form.subject_field"
                        ),
                      },
                    },
                    [
                      _c("b-input", {
                        model: {
                          value: _vm.templateSubject,
                          callback: function ($$v) {
                            _vm.templateSubject = $$v
                          },
                          expression: "templateSubject",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pages.closure_schedule.mail_templates.template_form.sender_field"
                        ),
                      },
                    },
                    [
                      _c("b-input", {
                        attrs: { type: "email" },
                        model: {
                          value: _vm.templateSender,
                          callback: function ($$v) {
                            _vm.templateSender = $$v
                          },
                          expression: "templateSender",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pages.closure_schedule.mail_templates.template_form.content_field"
                        ),
                      },
                    },
                    [
                      _c("vue-editor", {
                        model: {
                          value: _vm.templateContent,
                          callback: function ($$v) {
                            _vm.templateContent = $$v
                          },
                          expression: "templateContent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pages.closure_schedule.mail_templates.template_form.signature_field"
                        ),
                      },
                    },
                    [
                      _c("vue-editor", {
                        model: {
                          value: _vm.templateSignature,
                          callback: function ($$v) {
                            _vm.templateSignature = $$v
                          },
                          expression: "templateSignature",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "is-primary",
                        "icon-left": "play",
                        "native-type": "submit",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }